export enum RouteConstants{
    ServicePrivilege = 'serviceprivilege',
    Coco = 'cocouser',
    Guest = 'guest'
}